import styled from "styled-components"

export const StyledImageWidget = styled.img`
    width: 100%;
    margin-top: 5px;
`
